import React from "react";

export default function MailIcon({ size = 36, fill = "white" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
    >
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4.37l-8 4.36-8-4.36V6l8 4.36L20 6v2.37z" />
    </svg>
  );
}
